import { twMerge } from "tailwind-merge"
import { PointsIcon } from "./icons/PointsIcon"
import { PointsLeaderboardIcon } from "./icons/PointsLeaderboardIcon"

export function PointsCount({
	points,
	className,
	icon = "default",
}: {
	points: number
	className?: string
	icon?: "default" | "circle"
}) {
	return (
		<div
			className={twMerge(
				"flex items-center gap-1 rounded-[1px] border border-foreground/20 px-1.5 py-px text-xs [&>svg]:relative [&>svg]:bottom-px",
				className,
			)}
		>
			{icon === "circle" ? <PointsLeaderboardIcon /> : <PointsIcon />}
			{points}
		</div>
	)
}
